import { SizeUnit } from 'src/generated/graphql';
import { formatNumber } from './formatNumber';

export const sizeUnits = {
    [SizeUnit.SquareFeet]: 'sq. ft.',
    [SizeUnit.SquareMeters]: 'sq. m.',
};

export const calculateOfficeSize = (
    desks: number | undefined | null,
    size: number | undefined | null,
    sizeUnit: SizeUnit | undefined = SizeUnit.SquareFeet,
    useRSF?: boolean,
): string => {
    const sizeUnitString = useRSF ? 'RSF' : sizeUnits[sizeUnit];
    if (desks && !size) {
        return `${desks} Desks`;
    }
    if (size && !desks) {
        return `${formatNumber(size, { style: 'decimal', minimumFractionDigits: 0 })} ${sizeUnitString}`;
    }
    if (desks && size) {
        const sizeFormatted = formatNumber(size, { style: 'decimal', minimumFractionDigits: 0 });
        return `${desks} Desks / ${sizeFormatted} ${sizeUnitString}`;
    }
    return 'N/A';
};

export const convertSqFtToSqM = (sqFt: number | undefined | null) => (
    sqFt ? Math.round((sqFt / 10.76391042 + Number.EPSILON) * 100) / 100 : sqFt
);

export const convertSqMToSqFt = (sqM: number | undefined | null) => (
    sqM ? Math.round((sqM * 10.76391042 + Number.EPSILON) * 100) / 100 : sqM
);

export const convertAreaUnits = (value: number | undefined | null, unit: SizeUnit = SizeUnit.SquareFeet) => {
    if (value && unit === SizeUnit.SquareFeet) {
        return convertSqFtToSqM(value);
    }
    if (value && unit === SizeUnit.SquareMeters) {
        return convertSqMToSqFt(value);
    }
    return value;
};

export const convertMetresToMiles = (metres: number | undefined | null) => (
    metres ? Math.round((metres * 0.000621371192) * 10) / 10 : metres
);
